import { ConfirmDialog } from '@core/components';
import { useConfirmDialog } from '@core/hooks/useConfirmDialog';
import { type Order, deleteOrder } from '../../api/order';

export const DELETE_ORDER_DIALOG = {
  title: 'Delete order',
  content: 'Are you sure you want to delete this order?',
} as const;

interface DeleteOrderDialogProps {
  open: boolean;
  onClose: () => void;
  order: Order | null;
  onSuccess?: () => void;
}

const DeleteOrderDialog = ({
  open,
  onClose,
  order,
  onSuccess,
}: DeleteOrderDialogProps) => {
  const { loading, confirm, cancel } = useConfirmDialog({
    open,
    onClose,
    onConfirm: async () => {
      if (!order) return;
      await deleteOrder(order.id);
    },
    onSuccess,
    successMessage: 'Order deleted',
    errorMessage: 'Failed to delete order',
  });

  return (
    <ConfirmDialog
      open={open}
      title={DELETE_ORDER_DIALOG.title}
      content={DELETE_ORDER_DIALOG.content}
      confirmText="Delete"
      cancelText="Cancel"
      onConfirm={confirm}
      onCancel={cancel}
      loading={loading}
    />
  );
};

export default DeleteOrderDialog;
